import { BaseModel } from "./BaseModel";
import { CalculationHelper, CalculationModel } from "./CalculationHelper";
import { CalcualtionResultKeys, ColumnHeaders, TabNames } from '../modules/Constants';

export class ProfitAndLossModel extends BaseModel {
    overrideFormatSheet() {
        let header = this.Headers;
        let rows = this.Display;
        let columns = Array(rows[0].length).fill(0).map(() => ({ width: 150, numeric: false }));
        let blankRows = header.map((h, index) => { return { index: index, header: h } }).filter(item => item.header === "").map(item => item.index);
        columns[0].width = 300;

        let result = {}
        result.rows = rows.map(
            (row, rowIndex) => {
                let result = {}
                result.cells = columns.map((column, colIndex) => {
                    let cell = {};

                    if (colIndex === 0 && blankRows.includes(rowIndex) === false) {
                        cell = {
                            style: this.defaultHeader(),
                            wrap: true
                        }
                    } else {
                        if (this.Numerics.indexOf(rowIndex) > -1 && colIndex >= 1) {
                            cell = {
                                style: this.defaultHeader(),
                                format: '0.00%',
                                wrap: true
                            }
                        }
                        else if (rowIndex >= 5 && colIndex >= 1) {

                            let style = this.defaultCell();

                            if (header[rowIndex - 1] == "" || header[rowIndex] == ColumnHeaders.OPERATING_INCOME) {
                                style = this.defaultHeader();
                            }

                            cell = {
                                style: style,
                                format: '#,##0.00',
                                wrap: true
                            }
                        } else {
                            cell = {
                                style: this.defaultCell(),
                                wrap: true
                            }
                        }
                    }

                    let value = rows[rowIndex][colIndex] ?? "";

                    if (value[0] === '=') {
                        cell.formula = value;
                    } else {
                        cell.value = value;
                    }

                    if (!isFinite(cell.value)) {
                        cell.format = null;
                    }

                    return cell;
                })
                return result;
            })

        result.columns = columns.map((col) => ({ width: col.width }));

        return result
    }

    constructor() {
        super();
        this.TabName = TabNames.PROFIT_AND_LOSS;
        this.TabIndex = 1;
        this.DataProcessor = new ProfitAndLossProcessor();
        this.formatSheet = this.overrideFormatSheet;
    }

    static ProfitAndLossAcrossOptions() {

        let result = new ProfitAndLossModel();
        result.DataProcessor = new ProfitAndLossAcrossOptionsProccessor();

        return result;
    }
}

export class ProfitAndLossAcrossOptionsProccessor {
    process(data) {

        let headers = [];
        let records = [];
        let numerics = [];

        data.forEach(set => {
            let setData = Object.assign({}, set);
            setData.currency = data.currency;
            setData.returnRecords = true;
            let processor = new ProfitAndLossProcessor();
            let setResult = processor.process(setData);


            headers = setResult.headers;
            numerics = setResult.numerics;
            records = records.concat(setResult.display);
        });

        let helper = new ProfitAndLossProcessor();
        let display = helper.getDisplay(headers, records, data.currency);
        
        let result = {
            headers: headers,
            display: display,
            numerics: numerics
        };

        return result;
    }
}

export class ProfitAndLossProcessor {

    process(data) {
        let Calculations = [];
        let Calcs = data.calculations_parsed[1];
        let ExchangeRates = [];
        let Volumes = [];
        let Records = [];
        let Headers = [];
        let Currency = data.currency;
        let returnRecords = data.returnRecords ?? false;

        let study = data.study;
        let snapshots = data.snapshots;
        let version = data.version;

        study.exchangeRates.forEach(rate => {
            rate.Item2.Values.forEach(item => {
                ExchangeRates.push({
                    currency: rate.Item1,
                    year: new Date(item.Date).getUTCFullYear(),
                    value: item.Value
                });
            });
        });

        Calcs.forEach(calc => {
            Calculations.push(new CalculationModel(calc.calculationText, calc.calculation, calc.val, calc.amount, ExchangeRates, Currency))
        })

        snapshots.forEach(snapshot => {
            snapshot.SaleableParts.forEach(part => {
                let key = new CalculationHelper().getPartKey(part);
                Volumes[key] = { first: 0, total: 0, years: [] };

                var firstYearIndex = part.CostStudyVolume.Value.Fields[0].Values.findIndex(x => x.Value > 0)
                if (!firstYearIndex || firstYearIndex == -1) {
                    firstYearIndex = 0
                }
                let firstYear = part.CostStudyVolume.Value.Fields[0].Values[firstYearIndex];
                Volumes[key].first = firstYear.Value;
                Volumes[key].firstYear = new Date(firstYear.Date).getUTCFullYear();


                part.CostStudyVolume.Value.Fields.forEach(volume => {
                    volume.Values.forEach(value => {
                        Volumes[key].total += value.Value;
                        var year = new Date(value.Date).getUTCFullYear();
                        Volumes[key].years[year] = (Volumes[key].years[year] ?? 0) + value.Value;
                    });
                });
            });

        });

        var model = new ProfitAndLossRowModel(version, Calculations, Volumes);
        Records.push(model);

        Headers = this.configureHeader();
        let result = {
            headers: Headers,
            display: returnRecords === true ? Records : this.getDisplay(Headers, Records, Currency),
            numerics: this.getNumerics()
        };

        return result;
    }

    configureHeader() {
        let header = [
            "",
            ColumnHeaders.COST_STUDY,
            ColumnHeaders.VERSION,
            ColumnHeaders.CURRENCY_PREFIX,
            "",
            ColumnHeaders.VOLUME_K,
            "",
            ColumnHeaders.TOTAL_REVENUE,
            ColumnHeaders.OUTSIDE_PRODUCT_SALES,
            ColumnHeaders.PROTOTYPE_SALES,
            ColumnHeaders.ENGINEERING_REBILL,
            ColumnHeaders.TOOLING_REBILL,
            ColumnHeaders.FORWARD_LEVERAGE,
            ColumnHeaders.OTHER_REVENUE,
            "",
            ColumnHeaders.FACTORY_COST,
            ColumnHeaders.OUTSIDE_MATERIAL_INC_ALLIED,
            ColumnHeaders.INBOUND_FREIGHT,
            ColumnHeaders.INBOUND_DUTY,
            ColumnHeaders.EXPENDABLE_PACKAGING_FOR_SALEABLE_PRODUCT,
            ColumnHeaders.DIRECT_LABOR,
            ColumnHeaders.MANUFACTURING_COST_EXCLUDING_CURRENT_DEPRECIATION,
            ColumnHeaders.MANUFACTURING_ADJUSTMENT,
            ColumnHeaders.START_UP_LAUNCH_COST,
            ColumnHeaders.OPERATION_EXPENSES,
            ColumnHeaders.PROFIT_LOSS_OTHER_INCREMENTAL_COST,
            ColumnHeaders.TOOLING_REBILL_EXPENSE,
            "",
            ColumnHeaders.FACTORY_PROFIT,
            ColumnHeaders.FACTORY_MARGIN,
            "",
            ColumnHeaders.OTHER_OCOGS,
            ColumnHeaders.WARRANTY,
            ColumnHeaders.OUTBOUND_FREIGHT,
            ColumnHeaders.OCOGS,
            "",
            ColumnHeaders.COST_OF_SALES_DEPRECIATION_AND_AMORTIZATION,
            ColumnHeaders.MANUFACTURING_DEPRECIATION_CURRENT,
            ColumnHeaders.NEW_MANUFACTURING_DEPRECIATION,
            ColumnHeaders.SPECIAL_TOOLING_AMORTIZATION,
            ColumnHeaders.APPLICATION_ENGINEERING_AMORTIZATION,
            "",
            ColumnHeaders.GROSS_PROFIT,
            ColumnHeaders.GROSS_MARGIN,
            "",
            ColumnHeaders.OTHER_OPERATING_EXPENSES,
            ColumnHeaders.RESEARCH_ENGINEERING,
            ColumnHeaders.ROYALTY_EXPENSE,
            ColumnHeaders.PURSUIT_AND_CI_ENGINEERING,
            ColumnHeaders.SG_AND_A,
            ColumnHeaders.BANK_NOTE_DISCOUNTING_EXPENSE,
            "",
            ColumnHeaders.TOTAL_COST,
            ColumnHeaders.OPERATING_INCOME,
            ColumnHeaders.OPERATING_MARGIN,
            "",
            ColumnHeaders.NPV_K, 
            ColumnHeaders.IRR
        ];

        return header;
    }

    getDisplay(Headers, Records, Currency) {

        let display = [];

        display.push(Headers);

        let helper = new BaseModel();

        Records.forEach((record, index) => {
            let column = helper.excelLetter(index + 2)
            record.TotalCost = `=${column}16 + ${column}32 + ${column}37 + ${column}46`;

            let row = [
                "",
                record.CostStudy, 
                record.Version,
                Currency,
                "",
                record.VolumeK,
                "",
                record.TotalRevenue,
                record.OutsideProductSales,
                record.PrototypeSales,
                record.EngineeringRebill,
                record.ToolingRebill,
                record.ForwardLeverage,
                record.OtherRevenue,
                "",
                record.FactoryCost,
                record.OutsideMaterialIncludingAlliedMat,
                record.InboundFreight,
                record.InboundDuty,
                record.ExpendablePackagingForSaleableProduct,
                record.DirectLabor,
                record.ManufacturingCostExcludingCurrentDepreciation,
                record.ManufacturingAdjustment,
                record.StartUpLaunchCost,
                record.OperationExpenses,
                record.OtherIncrementalCost,
                record.ToolingRebillExpense,
                "",
                record.FactoryProfit,
                record.FactoryMargin,
                "",
                record.OtherOCOGS, 
                record.Warranty, 
                record.OutboundFreight, 
                record.OCOGS,
                "",
                record.CostOfSalesDepreciationAndAmortization,
                record.ManufacturingDepreciationCurrent,
                record.NewManufacturingDepreciation,
                record.SpecialToolingAmortization,
                record.ApplicationEngineeringAmortization,
                "",
                record.GrossProfit, 
                record.GrossMargin, 
                "",
                record.OtherOperatingExpenses,
                record.ResearchEngineering,
                record.RoyaltyExpense,
                record.PursuitAndCIEngineering,
                record.SGAndA,
                record.BankNoteDiscountingExpense,
                "",
                record.TotalCost,
                record.OperatingIncome,
                record.OperatingMargin,
                "",
                record.NPVk, 
                record.IRR

            ];

            display.push(row);
        });

        return display[0].map((_, colIndex) => display.map(row => row[colIndex]));
    }

    getNumerics() {
        let percents = [];
        let headers = this.configureHeader()
        percents.push(headers.indexOf(ColumnHeaders.FACTORY_MARGIN));
        percents.push(headers.indexOf(ColumnHeaders.GROSS_MARGIN));
        percents.push(headers.indexOf(ColumnHeaders.OPERATING_MARGIN));
        percents.push(headers.indexOf(ColumnHeaders.IRR));
        return percents;
    }
}

export class ProfitAndLossRowModel {
    CostStudy = "";
    Version = "";
    VolumeK = "";
    TotalRevenue = "";
    OutsideProductSales = "";
    PrototypeSales = "";
    EngineeringRebill = "";
    ToolingRebill = "";
    ForwardLeverage = "";
    OtherRevenue = "";
    FactoryCost = "";
    OutsideMaterialIncludingAlliedMat = "";
    InboundFreight = "";
    InboundDuty = "";
    ExpendablePackagingForSaleableProduct = "";
    DirectLabor = "";
    ManufacturingCostExcludingCurrentDepreciation = "";
    ManufacturingAdjustment = "";
    StartUpLaunchCost = "";
    OperationExpenses = "";
    OtherIncrementalCost = "";
    ToolingRebillExpense = "";
    FactoryProfit = "";
    FactoryMargin = ""
    OtherOCOGS = "";
    Warranty = "";
    OutbboundFreight = "";
    OCOGS = "";
    CostOfSalesDepreciationAndAmortization = "";
    ManufacturingDepreciationCurrent = "";
    NewManufacturingDepreciation = "";
    SpecialToolingAmortization = "";
    ApplicationEngineeringAmortization = "";
    GrossProfit = "";
    GrossMargin = "";
    OtherOperatingExpenses = "";
    ResearchEngineering = "";
    RoyaltyExpense = "";
    PursuitAndCIEngineering = "";
    SGAndA = "";
    BankNoteDiscountingExpense = "";
    TotalCost = "";
    OperatingIncome = "";
    OperatingMargin = "";
    NPVk = "";
    IRR = "";

    constructor(version, calculations, volumes) {

        console.log(calculations);
        let calculationHelper = new CalculationHelper();
        let volume = 0;
        this.CostStudy = version.ECRNumber.Value.Fields[0];
        this.Version = version.Name;


        for (var vKey in volumes) {
            volume += volumes[vKey].total;
        }
   
        let partData = calculations
        this.VolumeK = volume / 1000;


        this.TotalRevenue = calculationHelper.programAverageCalculation(partData, volume, [{ key: CalcualtionResultKeys.TOTAL_REVENUE, line: CalcualtionResultKeys.TOTAL_REVENUE }]);
        this.OutsideProductSales = calculationHelper.programAverageCalculation(partData, volume, [{ key: CalcualtionResultKeys.TOTAL_REVENUE, line: CalcualtionResultKeys.OUTSIDE_PRODUCT_SALES }]);
        this.PrototypeSales = calculationHelper.programAverageCalculation(partData, volume, [{ key: CalcualtionResultKeys.TOTAL_REVENUE, line: CalcualtionResultKeys.PROTOTYPE_SALES }]);
        this.EngineeringRebill = calculationHelper.programAverageCalculation(partData, volume, [{ key: CalcualtionResultKeys.TOTAL_REVENUE, line: CalcualtionResultKeys.ENGINEERING_REBILL }]);
        this.ToolingRebill = calculationHelper.programAverageCalculation(partData, volume, [{ key: CalcualtionResultKeys.TOTAL_REVENUE, line: CalcualtionResultKeys.TOOLING_REBILL_REVENUE }]);
        this.ForwardLeverage = calculationHelper.programAverageCalculation(partData, volume, [{ key: CalcualtionResultKeys.TOTAL_REVENUE, line: CalcualtionResultKeys.FORWARD_LEVERAGE }]);
        this.OtherRevenue = calculationHelper.programAverageCalculation(partData, volume, [{ key: CalcualtionResultKeys.TOTAL_REVENUE, line: CalcualtionResultKeys.OTHER_REVENUE }]);

        this.FactoryCost = calculationHelper.programAverageCalculation(partData, volume, [{ key: CalcualtionResultKeys.FACTORY_COST, line: CalcualtionResultKeys.FACTORY_COST }]);
        this.InboundFreight = calculationHelper.programAverageCalculation(partData, volume, [{ key: CalcualtionResultKeys.FACTORY_COST, line: CalcualtionResultKeys.INBOUND_FREIGHT }]);
        this.InboundDuty = calculationHelper.programAverageCalculation(partData, volume, [{ key: CalcualtionResultKeys.FACTORY_COST, line: CalcualtionResultKeys.INBOUND_DUTY }]);

        if (calculationHelper.hasNewMaterialBucket(partData)) {
            this.OutsideMaterialIncludingAlliedMat = calculationHelper.programAverageCalculation(partData, volume, [{ key: CalcualtionResultKeys.FACTORY_COST, line: CalcualtionResultKeys.MATERIAL }]);

        } else {
            this.OutsideMaterialIncludingAlliedMat = calculationHelper.programAverageCalculation(partData, volume, [{ key: CalcualtionResultKeys.FACTORY_COST, line: CalcualtionResultKeys.MATERIAL_AND_FREIGHT_DUTY }]) - (this.InboundFreight + this.InboundDuty);

        }

        this.ExpendablePackagingForSaleableProduct = calculationHelper.programAverageCalculation(partData, volume, [{ key: CalcualtionResultKeys.FACTORY_COST, line: CalcualtionResultKeys.EXPENDABLE_PACKAGING_FOR_SALEABLE_PRODUCT }]);
        this.DirectLabor = calculationHelper.programAverageCalculation(partData, volume, [{ key: CalcualtionResultKeys.FACTORY_COST, line: CalcualtionResultKeys.DIRECT_LABOR }]);
        this.ManufacturingCostExcludingCurrentDepreciation = calculationHelper.programAverageCalculation(partData, volume, [{ key: CalcualtionResultKeys.FACTORY_COST, line: CalcualtionResultKeys.TOTAL_BURDEN_WO_DIRECT_LABOR }]);
        this.ManufacturingAdjustment = calculationHelper.programAverageCalculation(partData, volume, [{ key: CalcualtionResultKeys.MANUFACTURING_COST, line: CalcualtionResultKeys.MANUFACTURING_ADJUSTMENT }]);
        this.StartUpLaunchCost = calculationHelper.programAverageCalculation(partData, volume, [{ key: CalcualtionResultKeys.FACTORY_COST, line: CalcualtionResultKeys.STARTUP_LAUNCH_COST }]);
        this.OperationExpenses = calculationHelper.programAverageCalculation(partData, volume, [{ key: CalcualtionResultKeys.FACTORY_COST, line: CalcualtionResultKeys.OPERATIONS_EXPENSE }]);
        this.OtherIncrementalCost = calculationHelper.programAverageCalculation(partData, volume, [{ key: CalcualtionResultKeys.FACTORY_COST, line: CalcualtionResultKeys.OTHER_INCREMENTAL_COST }]); 
        this.ToolingRebillExpense = calculationHelper.programAverageCalculation(partData, volume, [{ key: CalcualtionResultKeys.FACTORY_COST, line: CalcualtionResultKeys.TOOLING_REBILL_EXPENSE }]);

        this.FactoryProfit = calculationHelper.programAverageCalculation(partData, volume, [{ key: CalcualtionResultKeys.FACTORY_PROFIT, line: CalcualtionResultKeys.FACTORY_PROFIT }]);
        this.FactoryMargin = this.FactoryProfit / this.TotalRevenue;

        this.OtherOCOGS = calculationHelper.programAverageCalculation(partData, volume, [{ key: CalcualtionResultKeys.OTHER_COGS, line: CalcualtionResultKeys.OTHER_COGS }]);
        this.Warranty = calculationHelper.programAverageCalculation(partData, volume, [{ key: CalcualtionResultKeys.OTHER_COGS, line: CalcualtionResultKeys.WARRANTY_COST }]);
        this.OutboundFreight = calculationHelper.programAverageCalculation(partData, volume, [{ key: CalcualtionResultKeys.OTHER_COGS, line: CalcualtionResultKeys.OUTBOUND_FREIGHT }]); 
        this.OCOGS = calculationHelper.programAverageCalculation(partData, volume, [{ key: CalcualtionResultKeys.OTHER_COGS, line: CalcualtionResultKeys.OCOGS }]);

        this.CostOfSalesDepreciationAndAmortization = calculationHelper.programAverageCalculation(partData, volume, [{ key: CalcualtionResultKeys.COST_OF_SALES_DEPRECIATION_AND_AMORTIZATION, line: CalcualtionResultKeys.COST_OF_SALES_DEPRECIATION_AND_AMORTIZATION }]);
        this.ManufacturingDepreciationCurrent = calculationHelper.programAverageCalculation(partData, volume, [{ key: CalcualtionResultKeys.COST_OF_SALES_DEPRECIATION_AND_AMORTIZATION, line: CalcualtionResultKeys.MANUFACTURING_DEPRECIATION_CURRENT }]);
        this.NewManufacturingDepreciation = calculationHelper.programAverageCalculation(partData, volume, [{ key: CalcualtionResultKeys.COST_OF_SALES_DEPRECIATION_AND_AMORTIZATION, line: CalcualtionResultKeys.NEW_MANUFACTURING_DEPRECIATION }]);
        this.SpecialToolingAmortization = calculationHelper.programAverageCalculation(partData, volume, [{ key: CalcualtionResultKeys.COST_OF_SALES_DEPRECIATION_AND_AMORTIZATION, line: CalcualtionResultKeys.SPECIAL_TOOLING_AMORTIZATION }]);
        this.ApplicationEngineeringAmortization = calculationHelper.programAverageCalculation(partData, volume, [{ key: CalcualtionResultKeys.COST_OF_SALES_DEPRECIATION_AND_AMORTIZATION, line: CalcualtionResultKeys.APPLICATION_ENGINEERING_AMORTIZATION }]);

        this.GrossProfit = calculationHelper.programAverageCalculation(partData, volume, [{ key: CalcualtionResultKeys.GROSS_PROFIT, line: CalcualtionResultKeys.GROSS_PROFIT }]);
        this.GrossMargin = this.GrossProfit / this.TotalRevenue; 

        this.OtherOperatingExpenses = calculationHelper.programAverageCalculation(partData, volume, [{ key: CalcualtionResultKeys.OTHER_OPERATING_EXPENSES, line: CalcualtionResultKeys.OTHER_OPERATING_EXPENSES }]);
        this.ResearchEngineering = calculationHelper.programAverageCalculation(partData, volume, [{ key: CalcualtionResultKeys.OTHER_OPERATING_EXPENSES, line: CalcualtionResultKeys.RESEARCH_ENGINEERING }]);
        this.RoyaltyExpense = calculationHelper.programAverageCalculation(partData, volume, [{ key: CalcualtionResultKeys.OTHER_OPERATING_EXPENSES, line: CalcualtionResultKeys.ROYALTY_EXPENSE }]);
        this.PursuitAndCIEngineering = calculationHelper.programAverageCalculation(partData, volume, [{ key: CalcualtionResultKeys.OTHER_OPERATING_EXPENSES, line: CalcualtionResultKeys.PURSUIT_AND_CI_ENGINEERING }]);
        this.SGAndA = calculationHelper.programAverageCalculation(partData, volume, [{ key: CalcualtionResultKeys.OTHER_OPERATING_EXPENSES, line: CalcualtionResultKeys.SG_AND_A }]);
         this.BankNoteDiscountingExpense = calculationHelper.programAverageCalculation(partData, volume, [{ key: CalcualtionResultKeys.OTHER_OPERATING_EXPENSES, line: CalcualtionResultKeys.BANK_NOTE_DISCOUNTING_EXPENSE }]); 

        this.OperatingIncome = calculationHelper.programAverageCalculation(partData, volume, [{ key: CalcualtionResultKeys.OPERATING_INCOME, line: CalcualtionResultKeys.OPERATING_INCOME }]);
        this.OperatingMargin = this.OperatingIncome / this.TotalRevenue; 


        this.NPVk = calculationHelper.totalCalculation(partData, [{ key: CalcualtionResultKeys.DISCOUNTED_CASH_FLOW, line: CalcualtionResultKeys.DISCOUNTED_CASH_FLOW }]) / 1000;

        //IRR
        let netCashFlow = {};
        let partNetCashFlow = calculationHelper.perYearTotalCalculation(partData, [{ key: CalcualtionResultKeys.NET_CASH_FLOW, line: CalcualtionResultKeys.NET_CASH_FLOW }]);
        for (var pNCF in partNetCashFlow) {
            netCashFlow[pNCF] = calculationHelper.getNumber(netCashFlow[pNCF] ?? 0) + calculationHelper.getNumber(partNetCashFlow[pNCF] ?? 0);
        }

        let arrNetCashFlow = [];
        for (var ncfKey in netCashFlow) {
            arrNetCashFlow.push(netCashFlow[ncfKey]);
        }

        this.IRR = calculationHelper.irr(arrNetCashFlow);

    }

}